/// <amd-module name="Repos/PipelineStatus/Components/BranchPipelineStatus" />
import * as React from "react";
import { GitStatus } from "Repos/Common/Contracts/Git";
import { Components, VssComponent } from "VSS/Platform/Layout";
import { ReadyableArrayObserver } from "VSSUI/Observer";
import { IBranchStatusService } from "../BranchStatusService";
import { PipelineStatus } from "./PipelineStatus";

export interface IBranchPipelineStatusProps {
    className?: string;
    projectId: string;
    refName: string;
    repositoryId: string;
    renderNoStatus?: () => JSX.Element | null;
}

export class BranchPipelineStatus extends VssComponent<IBranchPipelineStatusProps> {
    public render() {
        const statusService = this.context.pageContext.getService<IBranchStatusService>("IBranchStatusService");
        const status = statusService.getBranchStatus(this.props.projectId, this.props.repositoryId, this.props.refName);

        return (
            <ReadyableArrayObserver
                data={status}
                dataComponent={items => {
                    const statuses = this.filterStatuses(items);
                    return <PipelineStatus className={this.props.className} statuses={statuses} />;
                }}
                zeroDataComponent={this.props.renderNoStatus}
            />
        );
    }

    private filterStatuses(statuses: GitStatus[]): GitStatus[] {
        const seenDefinitions = new Set<string>();
        const seenTargetUrls = new Set<string>();
        const results: GitStatus[] = [];
        for (const status of statuses) {
            const key = status.context.genre + "." + status.context.name;
            if (!seenDefinitions.has(key) && !seenTargetUrls.has(status.targetUrl)) {
                results.push(status);
                seenDefinitions.add(key);
                if (status.targetUrl) {
                    seenTargetUrls.add(status.targetUrl);
                }
            }
        }
        return results;
    }
}

Components.add("Repos.BranchPipelineStatus", BranchPipelineStatus);
